<template>
    <div id="navbar">
        <el-menu :default-active="activeIndex" active-text-color="#3894FF" @select="handleSelectTab" class="el-menu" mode="horizontal" :router="true">
            <div class="logo">
                <img width="177" height="45" src="@/assets/img/logo.png" alt="">
            </div>
            <el-menu-item index="/home">{{ $t('nav.home') }}</el-menu-item>
            <el-menu-item index="/service">{{ $t('nav.service') }}</el-menu-item>
            <el-menu-item index="/case">{{ $t('nav.case') }}</el-menu-item>
            <el-menu-item index="/partner">{{ $t('nav.partner') }}</el-menu-item>
            <el-menu-item index="/contact">{{ $t('nav.contact') }}</el-menu-item>
            <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                    <i class="iconfont icon-pifu"></i><span>{{ currentLang }}</span>
                </span>
                <el-dropdown-menu class="language" slot="dropdown">
                    <el-dropdown-item command="zh"><span>CHS</span></el-dropdown-item>
                    <el-dropdown-item command="en"><span>EN</span></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-menu>
    </div>
</template>
  
<script>
const langMap = {
    'zh': 'CHS',
    'en': 'EN'
};
export default {
    name: 'Navbar',
    data() {
        return {
            activeIndex: this.$route.matched[0].path,
        }
    },
    computed: {
        currentLang() {
            const lang = this.$i18n.locale || 'zh';
            return langMap[lang];
        }
    },
    methods: {
        // 切换菜单
        handleSelectTab(index) {
            this.activeIndex = index;
        },
        // 语言切换
        handleCommand(command) {
            this.$i18n.locale = command;
            localStorage.setItem('lang', command);
        }
    },
}
</script>
  
<style>
a {
    text-decoration: none;
}

.el-menu {
    display: flex;
    justify-content: end;
}

.el-dropdown {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    align-self: center !important;
    height: 30px;
    width: 40px;
    cursor: pointer;
    text-align: center;
}

.el-dropdown-link {
    color: #409EFF;
}

.el-menu-item {
    border: none !important;
}

.logo {
    flex: 1;
}
</style>
  